// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { useSocialDetails } from "../hooks/useSocialDetails";
import "./Footer.css";

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.41 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 6.29 6.29l.95-.95a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const LocationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

// Social SVG icons
function FacebookIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
    </svg>
  );
}
function InstagramIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
      <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
    </svg>
  );
}
function TwitterIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  );
}
function LinkedInIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
      <rect width="4" height="12" x="2" y="9"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  );
}
function YouTubeIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19.54C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
      <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#0d0d1a"/>
    </svg>
  );
}
function TikTokIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.27 8.27 0 0 0 4.84 1.56V6.81a4.85 4.85 0 0 1-1.07-.12z"/>
    </svg>
  );
}

var PAYMENT_BADGES = [
  { key: "footerVisaLogo",       fallback: "/visa.png",     label: "Visa"             },
  { key: "footerMastercardLogo", fallback: "/master.png",   label: "Mastercard"       },
  { key: "footerAmexLogo",       fallback: "/amex.png",     label: "American Express" },
  { key: "footerDiscoverLogo",   fallback: "/discover.png", label: "Discover"         },
];

var SOCIAL_CONFIG = [
  { key: "facebook",  Icon: FacebookIcon,  label: "Facebook"  },
  { key: "instagram", Icon: InstagramIcon, label: "Instagram" },
  { key: "twitter",   Icon: TwitterIcon,   label: "Twitter"   },
  { key: "linkedin",  Icon: LinkedInIcon,  label: "LinkedIn"  },
  { key: "youtube",   Icon: YouTubeIcon,   label: "YouTube"   },
  { key: "tiktok",    Icon: TikTokIcon,    label: "TikTok"    },
];

export default function Footer() {
  var { data: sd } = useSocialDetails();

  var phone   = sd.phone   || "0800 123 4567";
  var email   = sd.email   || "info@circuitprinting.ca";
  var address = sd.address || "Unit 5, Print Park";
  var city    = sd.city    || "Toronto, Canada";
  var hours   = sd.hours   || "Mon–Fri 8am–6pm, Sat 9am–2pm";

  var activeSocials = SOCIAL_CONFIG.filter(function(s) { return sd[s.key]; });

  return (
    <footer className="footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div style={{ marginBottom: 12 }}>
            <img src="/logo.jpeg" alt="Circuit Printing Solutions" style={{ height: 52, width: "auto", objectFit: "contain" }} />
          </div>
          <p>Professional printing solutions for businesses across Canada. Quality you can trust, prices that make sense.</p>
          {activeSocials.length > 0 && (
            <div className="footer-socials">
              {activeSocials.map(function(s) {
                return (
                  <a key={s.key} href={sd[s.key]} target="_blank" rel="noopener noreferrer" aria-label={s.label}>
                    <s.Icon />
                  </a>
                );
              })}
            </div>
          )}
        </div>

        <div className="footer-col">
          <h4>Products</h4>
          <Link to={"/products?group=" + encodeURIComponent("Business Cards")}>Business Cards</Link>
          <Link to={"/products?group=" + encodeURIComponent("Print Products")}>Print Products</Link>
          <Link to={"/products?group=" + encodeURIComponent("Stationery")}>Stationery</Link>
          <Link to={"/products?group=" + encodeURIComponent("Large Format")}>Large Format</Link>
          <Link to={"/products?group=" + encodeURIComponent("Labels & Packaging")}>Labels &amp; Packaging</Link>
          <Link to={"/products?group=" + encodeURIComponent("Promotions & Apparel")}>Promotions &amp; Apparel</Link>
        </div>

        <div className="footer-col">
          <h4>Company</h4>
          <Link to="/about">About Us</Link>
          <Link to="/blogs">Blog</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/contact">Request a Quote</Link>
          <Link to="/faq">FAQs</Link>
          <Link to="/artwork-guidelines">Artwork Guidelines</Link>
          <Link to="/submit-order">Submit Custom Order</Link>
          <Link to="/contact">Delivery Info</Link>
        </div>

        <div className="footer-col">
          <h4>Contact Us</h4>
          <p><span className="contact-icon"><PhoneIcon /></span>
            {sd.phone ? <a href={"tel:" + phone.replace(/\s/g,"")} style={{color:"inherit"}}>{phone}</a> : phone}
          </p>
          <p><span className="contact-icon"><EmailIcon /></span>
            {sd.email ? <a href={"mailto:" + email} style={{color:"inherit"}}>{email}</a> : email}
          </p>
          <p><span className="contact-icon"><LocationIcon /></span> {address}{city ? ", " + city : ""}</p>
          <p style={{ marginTop: 12, fontSize: 13, color: "rgba(255,255,255,0.5)" }}>{hours}</p>

          <div className="footer-payments">
            {PAYMENT_BADGES.map(function(b) {
              return <img key={b.key} src={sd[b.key] || b.fallback} alt={b.label} className="footer-payment-icon" />;
            })}
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>{sd.footerCopyrightText || "© 2026 Circuit Printing Solutions. All rights reserved."}</p>
          <a
            href={sd.footerCreditUrl || sd.footerDeveloperUrl || "https://ihostltd.com/"}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-credit"
          >
            <span>{sd.footerCreditText || "Design & Develop By"} {sd.footerDeveloperName || "AKassam"}</span>
            <img src={sd.footerCreditLogo || "/devlogo.jpeg"} alt={sd.footerDeveloperCompany || "The Ranking Giants"} className="footer-credit-logo" />
          </a>
          <div className="footer-bottom-links">
            <Link to={sd.footerPrivacyUrl || "/privacy-policy"}>Privacy Policy</Link>
            <Link to={sd.footerTermsUrl || "/privacy-policy"}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
